<template>
  <div class="gathering1">
    <p>
      Bakomliggande avtal och lön är det första steget för att få kontroll över din framtida pension.
    </p>

    <form class="gathering1__form">
      <p class="gathering1__form-label">Kollektivavtal</p>

      <span class="gathering1__form-radio-grouping">
        <label for="has" class="gathering1__form-radio gathering1__form-radio__has">
          <input
            type="radio"
            name="agreement"
            id="has"
            value="0"
            @change="[agreement = 99, setCollectiveAgreements()]"
            :checked="agreement != null"
          />
          Jag har kollektivavtal på jobbet

          <span class="gathering1__form-radio-checkmark"></span>
        </label>

        <label for="has-not" class="gathering1__form-radio">
          <input
            type="radio"
            name="agreement"
            id="has-not"
            value="1"
            @change="[agreement = null, setCollectiveAgreements()]"
            :checked="agreement == null"
          />
          Jag har inget kollektivavtal på jobbet

          <span class="gathering1__form-radio-checkmark"></span>
        </label>
      </span>
      <!-- Dropdown for radio button -->
      <div class="gathering1__form-dropdown-grouping" v-if="agreement != null">
        <img src="../../../../assets/svg/long-bendy-arrow-right.svg"/>
        <div class="gathering1__form-dropdown-container">
          <select
            id="agreements"
            name="agreements"
            class="gathering1__form-dropdown"
            v-model="agreement"
            @change="setCollectiveAgreements"
          >
            <option
              v-for="agreement in collectiveAgreements.agreements"
              :key="agreement.id"
              :value="agreement.id"
            >
              {{ agreement.name }}
            </option>
          </select>
        </div>
      </div>

      <span class="gathering1__form-range-grouping">
        <div class="gathering1__form-range-grouping-labels">
          <label
            class="gathering1__form-range-label"
            for="salary"
          >
            Min månadslön
          </label>
          <span
            class="gathering1__form-range-number"
            for="monthlySaving"
          >
            {{ monthlySalary }} kr/mån
          </span>
        </div>

        <span
          class="gathering1__form-range-wrapper"
          v-for="(data, i) in settingsData"
          :key="i"
        >
          <input
            @input="setInputStyle($event)"
            @mouseup="setTarget"
            @touchend="setTarget"
            class="gathering1__form-range"
            type="range"
            min="0"
            max="60000"
            v-model="monthlySalary"
            ref="monthlySalary"
            name="salary"
            id="salary"
          />
        </span>
      </span>

      <input
        class="gathering1__form-submit"
        type="submit"
        name="submit"
        id="submit"
        value="Nästa steg"
        v-on:click="done($event)"
      />
    </form>
  </div>
</template>

<script>
import LoadingSpinner from '../../LoadingSpinner.vue';
import { mapActions, mapGetters } from 'vuex';

export default {
  components: { LoadingSpinner },
  name: 'GatheringStep1',
  data () {
    return {
      monthlySalary: 0,
      agreement: this.$store.getters.user.access.collectiveAgreement,
    }
  },
  created () {
    if(!this.collectiveAgreements.status) {
      this.getCollectiveAgreements()
    }
  },
  mounted () {
    this.setInputStyle()
  },
  watch: {
    settingsData: {
      deep: true,
      immediate: true,
      handler (newValue) {
        if(newValue !== null) {
          this.monthlySalary = newValue[0].firstValue ?? this.monthlySalary
        }
      }
    },
  },
  methods: {
    ...mapActions(['updateUser', 'getCollectiveAgreements']),
    setInputStyle (e = false) {
      if (e) {
        let element = e.target;
        let percent = ((element.value - element.min)/(element.max - element.min))*100
        element.style.background = `linear-gradient(90deg,rgba(112, 112, 112, .25) ${percent}% , rgba(112, 112, 112, .08) ${percent}%)`
      } else {
        Object.keys(this.$refs).map(key=>{
          let element = this.$refs[key][0];
          let percent = ((element.value - element.min)/(element.max - element.min))*100
          element.style.background = `linear-gradient(90deg,rgba(112, 112, 112, .25) ${percent}% , rgba(112, 112, 112, .08) ${percent}%)`
        })
      }
    },
    async setTarget () {
      let data = {
        "title": "Inkomster",
        "field": "income",
        "firstValue": this.monthlySalary,
        "secondValue": this.user.access.income.averagePayIncreases,
        "labelOne": "Månadslön",
        "labelTwo": "Beräknad årlig löneökning",
      }

      this.$store.dispatch('updateUser', data)
    },
    async setCollectiveAgreements() {
      this.$store.dispatch('updateCollectiveAgreements', this.agreement)
    },
    done (event) {
      this.$emit('clicked', event);
    }
  },
  computed: {
    ...mapGetters([ 'user', 'collectiveAgreements' ]),
    settingsData() {
      let access = this.user.access;

      return ([
        {
          "title": "Inkomster",
          "field": "income",
          "firstValue": access.income.monthlySalary,
          "secondValue": access.income.averagePayIncreases,
          "labelOne": "Månadslön",
          "labelTwo": "Beräknad årlig löneökning"
        },
      ])
    }
  }
}
</script>

<style lang="scss" scoped>
.gathering1 {
  &__form {
    display: flex;
    flex-direction: column;

    &-label {
      font-weight: bold;
      font-family: "Roboto", sans-serif;
      color: $mainTextColor;
      margin-top: 2rem;
    }

    &-dropdown-grouping {
      display: flex;

      img {
        margin: -10px 10px 0 10px;
      }
    }

    &-dropdown-container {
      position: relative;
      width: 100%;

      &:after {
          content: url(../../../../assets/svg/down-arrow.svg);
          right: 10px;
          top: 27px;
          padding: 0 0 2px;
          position: absolute;
          pointer-events: none;
      }
    }

    &-dropdown {
      padding: .5rem 3rem .5rem .5rem;
      font-size: 1rem;
      margin-top: 1rem;
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      width: 100%;
    }

    &-radio-grouping {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin-top: 1rem;
    }

    &-radio {
      font-family: "Roboto", sans-serif;
      color: $gray;
      font-size: 1rem;
      display: block;
      position: relative;
      padding-left: 35px;
      margin-bottom: 12px;
      cursor: pointer;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;

        &__has {
          order: 2;

          @include breakpoints(medium) {
            order: 0;
          }
        }

      /* On mouse-over, add a grey background color */
      &:hover input ~ .gathering1__form-radio-checkmark {
        &:after {
          opacity: .5;
        }
      }

      /* Hide the browser's default radio button */
      input {
        position: absolute;
        opacity: 0;
        cursor: pointer;

        /* Show the indicator (dot/circle) when checked */
        &:checked ~ .gathering1__form-radio-checkmark::after {
          opacity: 1;
        }
      }

      /* Create a custom radio button */
      &-checkmark {
        position: absolute;
        top: 0;
        left: 0;
        height: 25px;
        width: 25px;
        background-color: #fff;
        border: 1px solid $mainTextColor;
        border-radius: 50%;

        &:after {
          /* Create the indicator (the dot/circle - hidden when not checked) */
          content: "";
          position: absolute;
          opacity: 0;
          /* Indicator */
          top: 5px;
          left: 5px;
          width: 13px;
          height: 13px;
          border-radius: 50%;
          background: $mediumGreen;
          transition: all .2s;
        }
      }
    }

    &-range-grouping {
      margin: 1rem 0 2rem 0;

      &-labels {
        display: flex;
        justify-content: space-between;
        margin-top: 2rem;
      }
    }

    &-range {
      -webkit-appearance: none;
      width: 100%;
      height: 1em;
      border-radius: $rounded;
      outline: none;
      opacity: 0.8;
      transition: opacity .2s ease-out;
      box-shadow: 0 .01em .05em $gray;

      &-label {
        font-weight: bold;
      }

      &-label, &-number {
        font-family: "Roboto", sans-serif;
        color: $mainTextColor;
        font-size: 1rem;
      }

      /* Mouse-over effects */
      &:hover {
        opacity: 1; /* Fully shown on mouse-over */
      }

      /* The slider handle (use -webkit- (Chrome, Opera, Safari, Edge) and -moz- (Firefox) to override default look) */
      &::-webkit-slider-thumb {
        -webkit-appearance: none;
        appearance: none;
        width: 1.8em;
        height: 1.8em;
        background: #0F7354 0% 0% no-repeat padding-box;
        border: .1em solid white;
        border-radius: 50%;
        cursor: pointer;
      }

      &::-moz-range-thumb {
        width: 1.8em;
        height: 1.8em;
        background: #0F7354 0% 0% no-repeat padding-box;
        border: .1em solid white;
        border-radius: 50%;
        cursor: pointer;
      }
    }

    &-range-wrapper {
      position: relative;
      margin: 0 auto 3rem;
    }

    &-range-bubble {
      color: $gray;
      padding: 4px 12px;
      position: absolute;
      border-radius: 4px;
      left: 50%;
      top: -29px;
      transform: translateX(-50%);
      font-size: 18px;

      &:after {
        content: "";
        position: absolute;
        width: 2px;
        height: 2px;
        top: -1px;
        left: 50%;
      }
    }

    &-submit {
      border-radius: 1.5em;
      border: none;
      cursor: pointer;
      font-size: 1rem;
      text-transform: uppercase;
      font-family: "Roboto", sans-serif;
      font-weight: bold;
      transition: all .5s;
      padding: 13px 25px;
      color: $white;
      background-color: $mediumGreen;

      &:hover {
        background-color: $lightGreen;
      }
    }

    @include breakpoints(medium) {
      &-dropdown-container {
        width: fit-content;
      }

      &-radio-grouping {
        display: grid;
        grid-template-columns: 1fr 1fr;
      }
    }
  }
}
</style>
